import { onMounted, onUnmounted, ref } from '@vue/composition-api';

import useActiveImageByMouse from '@/core/components/offer/offer-image/use-active-image-by-mouse';
import useSwipeImage from '@/core/components/offer/offer-image/use-swipe-image';

export default function useImageController(refs, images, isMobile) {
    let activeImageIndex = ref(0);

    const changeImageByIndicatorIndex = (event) => {
        activeImageIndex.value = +event.target.dataset.index;
    };

    onMounted(() => {
        const container = refs.imgWrapper;

        if (!isMobile) {
            useActiveImageByMouse(container, images, activeImageIndex);
        } else {
            useSwipeImage(container, images, activeImageIndex);

            refs.indicator?.forEach(indicatorItem => {
                indicatorItem.addEventListener('click', changeImageByIndicatorIndex);
            });
        }
    });

    if (isMobile) {
        onUnmounted(() => {
            refs.indicator?.forEach(indicatorItem => {
                indicatorItem.removeEventListener('click', changeImageByIndicatorIndex);
            });
        });
    }

    return activeImageIndex;
}
